import registryEntriesEndpoints from "./endpoints/registryEntries-endpoints";
import apiConfig from "../config/api";
import http from "./http";
import store from "../store/index";

const {
  getAllRegistryEntries,
  getDepartments,
  addRegistryEntry,
  getRegistryEntry,
  deleteRegistryEntry,
  editRegistryEntry,
} = registryEntriesEndpoints;
const { baseURL } = apiConfig;

const RegistryEntries = {
  async handleGetRegistryEntries(token, registryId, page = 1, pageSize = 100) {
    const getAllRegistryEntriesUrl = `${baseURL}${getAllRegistryEntries.GET()}?page=${page}&pageSize=${pageSize}`;
    http.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    return await http
      .get(
        getAllRegistryEntriesUrl,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        }
      )
      .catch((error) => {
        return error;
      });
  },
  async addRegistryEntry(registryEntry) {
    const getAddRegistryEntryUrl = `${baseURL}${addRegistryEntry.GET}`;
    return await http
      .post(
        getAddRegistryEntryUrl,
        {
          issuer: registryEntry.issuer,
          externalRegistrationNumber: registryEntry.externalRegistrationNumber,
          externalRegistrationDate: registryEntry.externalRegistrationDate,
          internalRegistrationNumber: registryEntry.internalRegistrationNumber,
          internalRegistrationDate: registryEntry.internalRegistrationDate,
          reservedNumberId: registryEntry.reservedNumberId,
          department: registryEntry.department,
          description: registryEntry.description,
          dispatchDate: registryEntry.dispatchDate,
          destination: registryEntry.destination,
          status: registryEntry.status,
          type: registryEntry.type,
          registryId: registryEntry.registryId,
          username: registryEntry.username,
          numberOfDaysToRespond: registryEntry.numberOfDaysToRespond,
          deadline: registryEntry.deadline,
          responseDescription: registryEntry.responseDescription,
          responseDate: registryEntry.responseDate,
          attachments: (registryEntry.attachments || []).map((a) =>
            typeof a === "string"
              ? { name: a.split("/").pop(), fileName: a.split("/").pop(), URI: a }
              : { ...a, URI: a.URI || a.uri }
          ),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
    .catch((error) => {
        return error;
      });
  },
  async handleEditRegistryEntry(registryEntry) {
    const getEditRegistryEntryUrl = `${baseURL}${editRegistryEntry.GET(
      registryEntry.id
    )}`;
    return await http
      .put(
        getEditRegistryEntryUrl,
        {
          id: registryEntry.id,
          issuer: registryEntry.issuer,
          externalRegistrationNumber: registryEntry.externalRegistrationNumber,
          externalRegistrationDate: registryEntry.externalRegistrationDate,
          internalRegistrationNumber: registryEntry.internalRegistrationNumber,
          internalRegistrationDate: registryEntry.internalRegistrationDate,
          dispatchDate: registryEntry.dispatchDate,
          destination: registryEntry.destination,
          department: registryEntry.department,
          description: registryEntry.description,
          status: registryEntry.status,
          registryId: registryEntry.registryId,
          type: registryEntry.type,
          username: registryEntry.username,
          numberOfDaysToRespond: registryEntry.numberOfDaysToRespond,
          deadline: registryEntry.deadline,
          responseDescription: registryEntry.responseDescription,
          responseDate: registryEntry.responseDate,
          attachments: (registryEntry.attachments || []).map((a) =>
            typeof a === "string"
              ? { name: a.split("/").pop(), fileName: a.split("/").pop(), URI: a }
              : { ...a, URI: a.URI || a.uri }
          ),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .catch((error) => {
        return error;
      });
  },
  async handleGetRegistryEntry(id) {
    const getGetRegistryEntryUrl = `${baseURL}${getRegistryEntry.GET(id)}`;
    http.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${store.state.token}`;
    return await http
      .get(
        getGetRegistryEntryUrl,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${store.state.token}`,
          },
        }
      )
      .catch((error) => {
        return error;
      });
  },

  async getAllDepartments() {
    const getDepartmentsUrl = `${baseURL}${getDepartments.GET()}`;
    http.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${store.state.token}`;
    return await http
      .get(
        getDepartmentsUrl,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${store.state.token}`,
          },
        }
      )
      .catch((error) => {
        return error;
      });
  },

  async deleteRegistryEntry(id) {
    const getDeleteRegistryEntryUrl = `${baseURL}${deleteRegistryEntry.GET(
      id
    )}`;
    return await http
      .delete(
        getDeleteRegistryEntryUrl,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .catch((error) => {
        return error;
      });
  },
};

export default RegistryEntries;
